import React, { useContext, useState, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import AppContext from "../../../state/AppContext";
import APIInvoke from '../../../utils/APIInvoke';
import { IconButton, Paper, Tooltip } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import TimelineIcon from '@mui/icons-material/Timeline';


const HighFrequency = ({ }) => {

    const [data, setData] = useState([]);
    const [counter, setCounter] = useState(0);
    const { appContext } = useContext(AppContext);
    const project = appContext.project
    const [loading, setLoading] = useState(false);
    const [timelapse, setTimelapse] = useState([]);
    const [isRunning, setIsRunning] = useState(false);
    const [showTimelapseDialog, setShowTimelapseDialog] = useState({
        show: false,
        startDate: null,
        endDate: null
    });

    // Efecto para actualizar el contador cada 10 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            if (!isRunning) return;
            fetchData();
        }, 10000);

        // Limpieza del intervalo cuando el componente se desmonte
        return () => clearInterval(interval);
    }, [isRunning]);

    useEffect(() => {
        if (loading) return;
        fetchData();
    }, [appContext.project]);

    const formatNumber = (value) => {
        if (value < 1000) return value.toString();
        if (value < 1000000) return `${(value / 1000).toFixed(1)}k`;
        if (value < 1000000000) return `${(value / 1000000).toFixed(1)}M`;
        return `${(value / 1000000000).toFixed(1)}B`;
    };

    const fetchData = async () => {
        try {
            if (!isRunning) {
                setLoading(true)
            }
            const response = await (await APIInvoke.invokeGET(`/projects/${appContext.project}/dashboard/high-frequency/status`)).json();
            setData(response.body);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };



    const getOption = (item) => {
        return {
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    const data = params[0].data;
                    return `${data.count} of ${data.maxUpdates}`;
                }
            },
            grid: {
                containLabel: false,
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
            },
            xAxis: {
                type: 'value',
                name: 'Número de Eventos',
                show: false,
                minInterval: 1,
                max: item.maxUpdates,
            },
            yAxis: {
                type: 'category',
                show: true,
                boundaryGap: true,
            },
            series: [{
                name: item.collection,
                type: 'bar',
                showBackground: true,
                data: [{
                    value: item.maxUpdates - (item.maxUpdates - item.count),
                    name: item.count,
                    maxUpdates: item.maxUpdates,
                    count: item.count,
                }],
                smooth: true,
                showSymbol: true,
                symbolSize: 6,
                animation: true,
                animationDuration: 300,
                animationEasing: 'cubicInOut',
                animationThreshold: 2000,
                progressive: 100,
                progressiveThreshold: 3000,
                itemStyle: {
                    color: '#22c55e',
                    borderColor: '#22c55e',
                    borderRadius: [0, 3, 3, 0]
                },
                backgroundStyle: {
                    color: 'rgba(180, 180, 180, 0.1)'
                },
                lineStyle: {
                    width: 2
                },
                areaStyle: {
                    opacity: 0.1
                }
            }]
        };
    }

    return (
        <div>
            <Paper className="">
                <div className="px-4 bg-gray-100 p-2 border-t border-gray-300 flex flex-row justify-between items-center">
                    <div className="flex flex-row items-center"><TimelineIcon fontSize="medium" className="text-dark-500"/><span className="pl-2">High frequency events</span></div>
                    <Tooltip title={isRunning ? "Stop" : "Start"} className="flex items-center">
                        <IconButton onClick={() => setIsRunning(!isRunning)}>
                            {isRunning
                                ? <StopCircleIcon className={isRunning ? "text-red-500 animate-pulse" : "text-red-500"} fontSize="medium" />
                                : <PlayCircleIcon className="text-green-500" fontSize="medium" />}
                        </IconButton>
                    </Tooltip>
                </div>
                <div className="grid gap-4 p-4">
                    {(data || []).length === 0 && <p className="text-center text-gray-700">No relevant activity</p>}
                    {(data || []).map((item, index) => (
                        <Link className="no-underline" to={`/projects/${appContext.project}/collections/${item.collection}/documents/${item.documentId}`}>
                            <div key={index} className="flex flex-row gap-2 items-center">
                                <Tooltip title={`${item.collection}`} className="w-24">
                                    <small className="truncate !text-xs"><small>{item.collection}</small><br />{item.documentKey}</small>
                                </Tooltip>
                                <ReactECharts
                                    option={getOption(item)}
                                    showLoading={loading}
                                    className="!h-8 !w-full !flex-1"
                                />
                            </div>
                        </Link>
                    ))}
                </div>
            </Paper>
        </div>

    );
}
export default HighFrequency;